import { getExperiment } from '@eventbrite/statsig';

export const HOMEPAGE_POPULAR_EVENTS_CAROUSEL_LOGGED_IN =
    'homepage_popular_events_carousel_logged_in';
export const HOMEPAGE_POPULAR_EVENTS_CAROUSEL_LOGGED_OUT =
    'homepage_popular_events_carousel_logged_out';
export const HOMEPAGE_POPULAR_EVENTS_CAROUSEL_PARAM = 'carousel';

export const shouldEnableCarousel = (isAuthenticated: boolean) => {
    const experimentName = isAuthenticated
        ? HOMEPAGE_POPULAR_EVENTS_CAROUSEL_LOGGED_IN
        : HOMEPAGE_POPULAR_EVENTS_CAROUSEL_LOGGED_OUT;

    const variant = getExperiment(
        experimentName,
        HOMEPAGE_POPULAR_EVENTS_CAROUSEL_PARAM,
        'hide',
    );

    return variant === 'show';
};
